import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-analytics-latest-activity',
  templateUrl: './analytics-latest-activity.component.html',
  styleUrls: ['./analytics-latest-activity.component.css']
})
export class AnalyticsLatestActivityComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/front/analytics-front/analytics-latest-activity/analytics-latest-activity.component.ts